/**
 * Gets the authId for non-logged users.
 * This endpoint is public and doesn't require authentication.
 *
 * `credentials: "include"` is REQUIRED so the browser:
 *   1) stores the `rgpt_device_id` HttpOnly cookie set by the backend, and
 *   2) sends it back on subsequent calls to this same endpoint,
 * which lets the backend recognize a returning non-logged user across IP changes.
 *
 * @returns Object with the resolved non-logged authId
 */
export const getNonLoggedAuthId = async (): Promise<{ authId: string }> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/non-logged-auth-id`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Failed to get non-logged authId: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error("Error getting non-logged authId:", error);
    throw error;
  }
};
